import React, { Suspense, lazy } from 'react';

// Lazy load page components to reduce main bundle size
const About = lazy(() => import('../../pages/About'));
const Contact = lazy(() => import('../../pages/Contact'));
const Products = lazy(() => import('../../pages/Products'));
const CategoriesList = lazy(() => import('../../pages/CategoriesList'));
const CategoryPage = lazy(() => import('../../pages/CategoryPage'));
const AdminGallery = lazy(() => import('../../pages/AdminGallery'));
const ProductDetail = lazy(() => import('../../pages/ProductDetail'));

// Loading component for better UX
const PageLoader = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
      <p className="text-gray-600">Loading...</p>
    </div>
  </div>
);

// Enhanced loading fallback with skeleton
const SkeletonLoader = () => (
  <div className="min-h-screen bg-gray-50 animate-pulse">
    <div className="max-w-7xl mx-auto px-6 py-20">
      <div className="h-8 bg-gray-300 rounded w-1/3 mb-6"></div>
      <div className="space-y-4">
        <div className="h-4 bg-gray-300 rounded w-full"></div>
        <div className="h-4 bg-gray-300 rounded w-5/6"></div>
        <div className="h-4 bg-gray-300 rounded w-4/6"></div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
        {[1, 2, 3].map(i => (
          <div key={i} className="h-48 bg-gray-300 rounded-lg"></div>
        ))}
      </div>
    </div>
  </div>
);

// Lazy components with enhanced loading states
export const LazyAbout = ({ useSkeletonLoader = false, ...props }) => (
  <Suspense fallback={useSkeletonLoader ? <SkeletonLoader /> : <PageLoader />}>
    <About {...props} />
  </Suspense>
);

export const LazyContact = ({ useSkeletonLoader = false, ...props }) => (
  <Suspense fallback={useSkeletonLoader ? <SkeletonLoader /> : <PageLoader />}>
    <Contact {...props} />
  </Suspense>
);

export const LazyProducts = ({ useSkeletonLoader = false, ...props }) => (
  <Suspense fallback={useSkeletonLoader ? <SkeletonLoader /> : <PageLoader />}>
    <Products {...props} />
  </Suspense>
);

export const LazyCategoriesList = ({ useSkeletonLoader = false, ...props }) => (
  <Suspense fallback={useSkeletonLoader ? <SkeletonLoader /> : <PageLoader />}>
    <CategoriesList {...props} />
  </Suspense>
);

export const LazyCategoryPage = ({ useSkeletonLoader = false, ...props }) => (
  <Suspense fallback={useSkeletonLoader ? <SkeletonLoader /> : <PageLoader />}>
    <CategoryPage {...props} />
  </Suspense>
);

export const LazyAdminGallery = ({ useSkeletonLoader = false, ...props }) => (
  <Suspense fallback={useSkeletonLoader ? <SkeletonLoader /> : <PageLoader />}>
    <AdminGallery {...props} />
  </Suspense>
);

export const LazyProductDetail = ({ useSkeletonLoader = false, ...props }) => (
  <Suspense fallback={useSkeletonLoader ? <SkeletonLoader /> : <PageLoader />}>
    <ProductDetail {...props} />
  </Suspense>
);

// Export for direct use
export { 
  About as LazyAboutDirect,
  Contact as LazyContactDirect,
  Products as LazyProductsDirect,
  CategoriesList as LazyCategoriesListDirect,
  CategoryPage as LazyCategoryPageDirect,
  AdminGallery as LazyAdminGalleryDirect,
  ProductDetail as LazyProductDetailDirect
};
